import { COU_httpGet, COU_httpPost } from "@/utils/http";

// 获取 1688商品详情
async function GetGoodsDetail(itemId, branchRelId) {
  var url = `/ali/productInfo?branchRelId=${branchRelId}&itemId=${itemId}`;
  var r = await COU_httpGet({ url });
  var msg = ``;
  var success = false;
  var goodsDetail = {};
  try {
    msg = r.msg;
    success = r.success;
    goodsDetail = r.result;
  } catch (error) {
    console.log(error);
  }

  return { msg, success, goodsDetail };
}

// 取消上次生成的订单
async function CancelTb1688Order(orderId, branchRelId) {
  var url = `oneorder/order/ali/orderCancel?branchRelId=${branchRelId}`;
  var data = {
    orderId,
  };
  var r = await COU_httpPost({ url, data });
  var msg = ``;
  var isSuccess = false;
  try {
    msg = r.msg;
    isSuccess = r.success;
  } catch (error) {
    console.log(error);
  }
  return { isSuccess, msg };
}

// 生成订单
async function CreatedTb1688Order(data, branchRelId) {
  var url = `/oneorder/order/ali/createOrder?branchRelId=${branchRelId}`;
  // var url = branchRelId
  // ? `/oneorder/order/ali/createOrder?branchRelId=${branchRelId}`
  // : `/oneorder/order/ali/createOrder`;
  var r = await COU_httpPost({ url, data });
  var msg = ``;
  let code = "";
  var isSuccess = false;
  var created1688OrderId = ``;
  try {
    code = r.code;
    msg = r.msg;
    isSuccess = r.success;
    created1688OrderId = r.result.OrderId;
  } catch (error) {
    console.log(error);
  }
  return { msg, isSuccess, created1688OrderId, code };
}

// 批量创建支付
async function BatchCreatePay(orderIds, branchRelId) {
  var url = `/oneorder/order/ali/batchCreatePay?branchRelId=${branchRelId}`;
  var data = {
    orderIds,
  };
  var r = await COU_httpPost({ url, data });
  var appOrderIds = [];
  var payUrl = ``;
  var msg = ``;
  var isSuccess = false;
  try {
    msg = r.msg;
    isSuccess = r.success;
    appOrderIds = r.result.AppOrderIds;
    payUrl = r.result.PayUrl;
  } catch (error) {
    console.log(error);
  }

  return { msg, isSuccess, appOrderIds, payUrl };
}

// 查询订单详情
async function SearchCreated1688Order(orderId) {
  var url = `/oneorder/order/ali/orderDetail`;
  var data = {
    orderId,
  };
  var r = await COU_httpPost({ url, data });
  var tb1688OrderInfo = {};
  var isSuccess = false;
  var msg = ``;
  try {
    msg = r.msg;
    isSuccess = r.success;
    tb1688OrderInfo = r.result;
  } catch (error) {
    console.log(msg);
  }
  return { tb1688OrderInfo, isSuccess, msg };
}

// 同步订单物流
async function GetLogisticsInfoByMyApi(orderId) {
  var url = `/oneorder/order/ali/orderLogistics`;
  var data = { orderId };
  var r = await COU_httpPost({ url, data });
  var logisticsInfo = {};
  var errMsg = ``;
  var isCollect = true;
  try {
    errMsg = r.msg;
    logisticsInfo = r.result.LogisticInfos;
    logisticsInfo["shipping_name"] = r.result.LogisticInfos[0]?.LogisticsName;
    logisticsInfo["tracking_number"] = r.result.LogisticInfos[0]?.TrackingNumber;
    logisticsInfo["traces"] = updataTraces(r.result.LogisticInfos[0]?.LogisticTracks);
    if (!r.result.LogisticInfos[0]?.LogisticTracks) isCollect = false;
    logisticsInfo["isCollect"] = isCollect;
  } catch (error) {
    console.log(error);
  }
  return { logisticsInfo, errMsg };
}

async function GetLogisticsInfo(orderId) {
  var url = `/oneorder/order/ali/orderLogistics`;
  var data = {
    orderId,
  };
  var r = await COU_httpPost({ url, data });
  var msg = ``;
  var isSuccess = false;
  var result = {};
  try {
    msg = r.msg;
    isSuccess = r.success;
    result = r.result;
  } catch (error) {
    console.log(error);
  }
  return { msg, isSuccess, result, logisticsList: result.LogisticInfos };
}
//查物流公司列表
async function LogisticCompanyList(branchRelId) {
  var url = `/oneorder/order/ali/logisticCompanyList?branchRelId=${branchRelId}`;

  var r = await COU_httpPost({ url });
  var msg = ``;
  var isSuccess = false;
  var result = {};
  try {
    msg = r.msg;
    isSuccess = r.success;
    result = r.result;
  } catch (error) {
    console.log(error);
  }
  return { msg, isSuccess, result, logisticsList: result };
}
function updataTraces(LogisticTracks) {
  if (!LogisticTracks || (LogisticTracks && LogisticTracks.length == 0)) return;
  var traces = LogisticTracks.map((item) => {
    var newItem = {
      place: item.Remark,
      time: item.AcceptTime,
    };
    return newItem;
  });
  return traces;
}

// 免密支付
async function AutoPay1688order(orderId, branchRelId) {
  var url = `/oneorder/order/ali/protocolPay?branchRelId=${branchRelId}`;
  var data = {
    orderId,
  };
  var r = await COU_httpPost({ url, data });
  var msg = ``;
  var isSuccess = false;
  var result = {};
  try {
    msg = r.msg;
    isSuccess = r.success;
    result = r.result;
  } catch (error) {
    console.log(error);
  }
  return { msg, isSuccess, result };
}

// 搜图
async function SearchTb1688GoodsByImg(data, branchRelId) {
  var url = `/ali/imageSearchItemList?branchRelId=${branchRelId}`;
  var r = await COU_httpPost({ url, data });
  var itemList = [];
  var msg = ``;
  var isSuccess = false;
  let isAuth = false;
  try {
    msg = r.msg;
    isSuccess = r.success;
    itemList = r.result;
    isAuth = r.code === 2000;
  } catch (error) {
    console.log(error);
  }
  if (!itemList && !isAuth) itemList = [];
  return { itemList, msg, isSuccess, isAuth };
}
// 1688模块授权
async function GetTb1688BindInfo(relationId) {
  var url = `/ali/getBindInfo?relationId=${relationId}`;
  var r = await COU_httpPost({ url });
  var info = {};
  var msg = ``;
  var isSuccess = false;
  try {
    info = r.result;
    msg = r.msg;
    isSuccess = r.success;
  } catch (error) {
    console.log(error);
  }

  return { info, msg, isSuccess };
}
// 关键词
async function SearchTb1688GoodsByKeyword({ keyword }, currentPage, pageSize, branchRelId) {
  var url = `ali/productList?branchRelId=${branchRelId}&page=${currentPage}&size=${pageSize}&keyword=${keyword}`;
  var r = await COU_httpGet({ url });
  let itemList = [];
  let total = 0;
  var msg = ``;
  var success = false;
  try {
    msg = r.msg;
    success = r.success;
    total = r.result.TotalNum;
    itemList = r.result.Datas;
  } catch (error) {
    console.log(error);
  }

  return { itemList: itemList || [], total, success, msg };
}

// 1688口令解析
async function GetTb1688ParseLink(u) {
  const url = `/util/aliTrueUrl`;
  const r = await COU_httpPost({ url, data: { u } });
  let link,
    msg,
    isSuccess = false;
  try {
    link = r.result;
    isSuccess = r.success;
    msg = r.msg;
  } catch (error) {
    console.log(error);
  }
  return { link, msg, isSuccess };
}

export default {
  GetTb1688BindInfo,
  GetGoodsDetail,
  CancelTb1688Order,
  CreatedTb1688Order,
  LogisticCompanyList,
  BatchCreatePay,
  SearchCreated1688Order,
  GetLogisticsInfoByMyApi,
  GetLogisticsInfo,
  AutoPay1688order,
  SearchTb1688GoodsByImg,
  SearchTb1688GoodsByKeyword,
  GetTb1688ParseLink,
};
